/**
 * Styled components for ServiceabilityInfoStep
 */
import styled from 'styled-components';
import { Button, Input, Select, Table, Modal } from 'antd';
import { Box, Text } from 'atoms';

export const HeaderContainer = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
`;

export const SectionTitle = styled(Text)`
	font-size: 18px;
	font-weight: 600;
	color: #1c1c1c;
`;

export const BulkUploadButton = styled(Button)`
	background-color: #fff;
	color: #18405d;
	border: 1px solid #18405d;
	border-radius: 4px;
	padding: 8px 20px;
	height: auto;
	font-size: 14px;
	font-weight: 500;

	&:hover {
		background-color: #f0f5f9 !important;
		color: #18405d !important;
		border-color: #18405d !important;
	}
`;

export const StyledInput = styled(Input)`
	border-radius: 4px;
	font-size: 14px;
	padding: 8px 12px;
	background-color: #f5f5f5;

	&::placeholder {
		color: #bfbfbf;
		font-size: 13px;
	}

	&:disabled {
		background-color: #f5f5f5;
		color: #8c8c8c;
		cursor: not-allowed;
	}
`;

export const StyledSelect = styled(Select)`
	width: 100%;

	.ant-select-selector {
		border-radius: 4px;
		font-size: 14px;
		padding: 4px 12px !important;
		height: auto !important;
		min-height: 40px;
	}

	.ant-select-selection-placeholder {
		color: #bfbfbf;
		font-size: 13px;
	}
`;

export const AddRouteButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 10px 32px;
	height: auto;
	font-size: 15px;
	font-weight: 500;
	margin-top: 20px;

	&:hover {
		background-color: #153e60 !important;
		color: #fff !important;
	}
`;

export const ViewButton = styled(Button)`
	color: #18405d;
	border: none;
	padding: 0;
	height: auto;
	background: transparent;

	&:hover {
		color: #153e60 !important;
	}
`;

export const StyledTable = styled(Table)`
	margin-top: 32px;

	.ant-table {
		border: 1px solid #e0e0e0;
		border-radius: 8px;
	}

	.ant-table-thead > tr > th {
		background-color: #18405d;
		color: #fff;
		font-weight: 600;
		font-size: 14px;
		border: none;
		padding: 12px 16px;

		&:first-child {
			border-top-left-radius: 8px;
		}

		&:last-child {
			border-top-right-radius: 8px;
		}
	}

	.ant-table-tbody > tr > td {
		padding: 12px 16px;
		font-size: 14px;
		color: #1c1c1c;
	}

	.ant-table-tbody > tr:hover > td {
		background-color: #f5f5f5;
	}
`;

export const StyledModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 8px;
	}

	.ant-modal-header {
		padding: 20px 24px;
		border-bottom: 1px solid #e0e0e0;
	}

	.ant-modal-title {
		font-size: 18px;
		font-weight: 600;
		color: #1c1c1c;
	}

	.ant-modal-body {
		padding: 24px;
	}

	.ant-modal-footer {
		padding: 16px 24px;
		border-top: 1px solid #e0e0e0;
		display: flex;
		justify-content: space-between;
	}
`;

export const RemoveButton = styled(Button)`
	color: #ff4d4f;
	border: 1px solid #ff4d4f;
	border-radius: 4px;
	padding: 8px 24px;
	height: auto;
	font-size: 15px;
	font-weight: 500;

	&:hover {
		background-color: #fff1f0 !important;
		color: #ff4d4f !important;
		border-color: #ff4d4f !important;
	}
`;

export const SaveButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 24px;
	height: auto;
	font-size: 15px;
	font-weight: 500;

	&:hover {
		background-color: #153e60 !important;
		color: #fff !important;
	}
`;
